import { ISortBoxModel } from "../sortbox/ISortBoxModel";
import { setRxBoxModel } from "../store/reducers/rxBoxModeReducer";

export default class RxBox {
    rxSortBoxModel: ISortBoxModel;

    constructor(rxSortBoxModel: ISortBoxModel) {
        this.rxSortBoxModel  = rxSortBoxModel;
    }

    load() {
        if (this.rxSortBoxModel.notFound) {
        } else {
            //do parsing and chaning props if needed
        }
    }
}